module.exports = __webpack_public_path__ + "img/218M带纸顶.245.62e7f916.png";